// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__31uiX","description":"PatientConsentPreview_description__3FXmd"};